import './Header.scss';
import React from 'react';
import Logo from '../../assets/images/ambion_logo.png';

const HeaderComponent = () => {
  return (
    <>
      <header className='Header'>
        <div className='container'>
          <img src={Logo} alt='Ambion Logo' />
        </div>
      </header>
    </>
  );
};

export default HeaderComponent;
